import { createApp } from 'vue';
import axios from 'axios';
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import { createPinia } from 'pinia';
import ToastService from 'primevue/toastservice';
import Router from '@/front/routes.js';
import Layout from '@/front/views/shared/layout.vue';
import VueApexCharts from 'vue3-apexcharts';
import '@/front/styles/main.css';
import 'primeicons/primeicons.css';

const csrfToken = document
  .querySelector('meta[name="csrf-token"]')
  ?.getAttribute('content');
if (csrfToken) {
  axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
}

const app = createApp(Layout);
const pinia = createPinia();

app
  .use(Router)
  .use(pinia)
  .use(ToastService)
  .use(VueApexCharts)
  .use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        darkModeSelector: false
      }
    }
  })
  .mount('#app');
